import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { url: String }

  open() {
    if (typeof this.inputTarget.showPicker === "function") {
      this.inputTarget.showPicker()
    } else {
      this.inputTarget.focus()
      this.inputTarget.click()
    }
  }

  navigate() {
    if (!this.inputTarget.value) return

    const url = new URL(this.urlValue, window.location.origin)
    const [year, month, day] = this.inputTarget.value.split("-").map((part) => String(Number(part)))
    const path = url.pathname.split("/")
    path.splice(-4, 3, year, month, day)
    url.pathname = path.join("/")

    if (window.Turbo) {
      window.Turbo.visit(url.toString())
    } else {
      window.location.assign(url.toString())
    }
  }
}
